<template>
  <v-container fluid grid-list-md>
    <v-card>
      <v-form id="profile">
        <v-flex style="display: flex">
          <v-select
            :items="languageNames"
            :label="$vuetify.t('$vuetify.Translation.selectLanguage')"
            v-model="selectedLanguage"
            item-text="text"
            item-value="value"
          ></v-select>
          <v-btn
            dark
            color="green darken-1"
            form="check-profile-form"
            @click.stop="selectLanguage">{{ $vuetify.t('$vuetify.UserSettings.save') }}</v-btn>
        </v-flex>
      </v-form>
    </v-card>
  </v-container>
</template>

<script>
  export default {
    data: function () {
      return {
        selectedLanguage: this.$store.getters.translationLanguage,
        languages: this.$store.getters.supportedLanguages
      }
    },
    computed: {
      languageNames () {
        let languageList = []
        this.languages.forEach(element => {
          languageList.push({value: element.value, text: this.$vuetify.t('$vuetify.Translation.' + element.text)})
        })
        return languageList
      }
    },
    methods: {
      selectLanguage: function () {
        this.$store.commit('SET_TRANSLATION_LANGUAGE', this.selectedLanguage)
      }
    }
  }
</script>

<style lang="scss" scoped>

</style>